import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Disable uppercase text
          fontSize: '1rem', // Set a custom font size
          fontWeight: 'bold', // Set a custom font weight
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          textTransform: 'none', // Disable capitalization
          color: '#333', // Set a custom text color
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: 'white', // Set text color to white for all AppBar content
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#FF69B4', // Pink color
    },
    secondary: {
      main: '#dc004e', // Customize the secondary color
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif', // Set a custom font family
    h1: {
      fontSize: '2.5rem', // Customize the h1 font size
    },
  },
});

export default theme;